import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import SchemaPartItem, { ItemHeader, itemTitlePreview, itemTitleTranslationKey } from '../SurveyPartItem';
import { schemaPartItemTypeValues, SurveySchemaPartItemEditorType } from '../../../../constants/types';
import { langType, withLang } from '../../../../i18n';
import styles from './surveyPartItemDragAndDrop.module.css';

const PART_ITEM_HEADER_HEIGHT = 2.75;

class SurveyPartItemDragAndDrop extends Component {
  constructor(props) {
    super(props);

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(draggedItem) {
    const { updateSchemaPartItemOrder, schemaPartItems } = this.props;

    if (!draggedItem.destination) {
      return;
    }

    const reorderedItems = [...schemaPartItems];
    const [removedItem] = reorderedItems.splice(draggedItem.source.index, 1);
    const destinationIndex = draggedItem.destination.index < 0 ? 0 : draggedItem.destination.index;
    reorderedItems.splice(destinationIndex, 0, removedItem);

    updateSchemaPartItemOrder(reorderedItems);
  }

  renderSchemaPartItem(item, index) {
    const { translate, lang, itemElementsOpen } = this.props;
    const isOpen = itemElementsOpen[index];
    return (
      <Draggable
        key={item.order}
        draggableId={`${item.order}`}
        index={index}
        isDragDisabled={this.props.lockedFromEditing}
      >
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={provided.draggableProps.style}
            className={`${snapshot.isDragging && styles.itemDragging}`}
          >
            <div {...provided.dragHandleProps}>
              <ItemHeader
                isOpen={isOpen}
                titleTranslationKey={itemTitleTranslationKey(item)}
                preview={itemTitlePreview(item, translate, lang)}
                toggleOpen={this.props.onToggleShowElement(index)}
              />
            </div>
            <SchemaPartItem
              item={item}
              isOpen={isOpen}
              onToggleVisible={this.props.onToggleShowElement(index)}
              onRemove={this.props.onRemoveSchemaPartItem(index)}
              nextFreeQuestionCode={item.type === schemaPartItemTypeValues.QUESTION_GROUP
                ? this.props.nextFreeQuestionCode
                : null}
              lockedFromEditing={this.props.lockedFromEditing}
              withHeader={false}
            />
          </div>
        )}
      </Draggable>
    );
  }

  render() {
    const items = this.props.schemaPartItems;
    const droppableStyles = { minHeight: `${items.length * PART_ITEM_HEADER_HEIGHT}em` };

    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={droppableStyles}
                className={`${snapshot.isDraggingOver && styles.draggingList}`}
              >
                {items.map((item, idx) => this.renderSchemaPartItem(item, idx))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  }
}

const { func, arrayOf, bool } = PropTypes;
SurveyPartItemDragAndDrop.propTypes = {
  schemaPartItems: arrayOf(SurveySchemaPartItemEditorType).isRequired,
  nextFreeQuestionCode: func.isRequired,
  updateSchemaPartItemOrder: func.isRequired,
  onRemoveSchemaPartItem: func.isRequired,
  itemElementsOpen: arrayOf(bool).isRequired,
  onToggleShowElement: func.isRequired,
  lockedFromEditing: bool.isRequired,
  ...langType
};

export default withLang(SurveyPartItemDragAndDrop);
